export const GET_ALL_POKEMONS = "GET_ALL_POKEMONS";
export const GET_POKEDETAILS = "GET_POKEDETAILS";
export const GET_TYPES = "GET_TYPES";
export const CLEAN_POKEMONS = "CLEAN_POKEMONS";
export const CLEAN_DETAIL = "CLEAN_DETAIL";
export const POST_DATA_REQ = "POST_DATA_REQ";
export const POST_DATA_SUCC = "POST_DATA_SUCC";
export const POST_DATA_FAIL = "POST_DATA_FAIL";
export const GET_MY_POKEMONS = "GET_MY_POKEMONS";
export const DELETE_POKEMON = "DELETE_POKEMON";
